import DiagnosticModal from '@/views/consultations/en-cours/hypothese-diagnostic/manage-diagnosis';
import $ from 'jquery'

export default {
    name: 'hypothese-diagnostic',
    components: {
        DiagnosticModal
    },
    props: {
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        evolution_toggler: Number,
        current_consultation_evolution: Number
    },
    data() {
        return {
            hypothese_loading: true,
            hypothese_is_empty: false,

            group_id: 0,
            data_info: {
                is_diagnostic: 0,
                libelle: 'Hypothèse diagnostique',
                data_type: 'hypothese_diagnostique'
            },
            modal_toggler: 0,
            data_to_be_deleted: {}
        }
    },

    watch: {
        evolution_toggler() {
            this.getHypotheseDiagnostique()
        }
    },

    computed: {
        hypothese_diagnostiques() {
            return this.$store.getters["hypothese_diagnostiques"]
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        }
    },

    mounted() {
        // Fetch Hypotheses Diagnostiques
        this.getHypotheseDiagnostique()
    },

    methods: {
        getHypotheseDiagnostique() {
            this.hypothese_loading = true
            let data = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id_initiale,
                is_diagnostic: 0,
                data_type: 'hypothese_diagnostique',
                enCours: true
            }
            this.$store.dispatch("getConsultationDiagnostics", data).then(() => {
                if (this.hypothese_diagnostiques.length > 0) {
                    this.hypothese_is_empty = false
                } else {
                    this.hypothese_is_empty = true
                }
                this.hypothese_loading = false
            })
        },

        addToListHypothese(group_id) {
            this.group_id = group_id
            this.modal_toggler = (this.modal_toggler === 0)?1:0

            this.data_info = {
                is_diagnostic: 0,
                libelle: 'Hypothèse diagnostique',
                data_type: 'hypothese_diagnostique'
            }
            $('.diagnosis-mdl-'+this.evolution_id+this.data_info.data_type).modal('show')
        },

        removeDiagnosis(data, group_id) {
            this.data_to_be_deleted = {
                id: data.id,
                libelle: data.libelle,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                user_id: this.userCredentials.id,
                group_id: group_id,
                data_type: 'hypothese_diagnostique',
                is_diagnostic: 0
            }
            $('.del-diagnosis-'+this.evolution_id+this.data_info.data_type).modal('show')
        },

        removeGroupDiagnosis(group_diagnosis) {
            this.data_to_be_deleted = {
                libelle: group_diagnosis.reference,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                user_id: this.userCredentials.id,
                group_id: group_diagnosis.diagnosis_group_id,
                data_type: 'hypothese_diagnostique'
            }
            $('.del-grp-diagnosis-'+this.evolution_id+this.data_info.data_type).modal('show')
        },
    }
}
